import { useCustomizer } from '../hooks/index.js'
import { CustomizerActionType } from '../types.js'

export const EditBlockEditor = () => {
  const {
    state: { blockSettings },
    dispatch,
  } = useCustomizer()

  const settings = blockSettings[blockSettings.length - 1]
  return (
    <div className="px-2">
      <settings.Component
        {...settings.additionalProps}
        deactivateBlock={() =>
          dispatch({
            type: CustomizerActionType.DEACTIVATE_BLOCK,
          })
        }
        pushSettings={(title, Component, additionalProps) =>
          dispatch({
            type: CustomizerActionType.PUSH_BLOCK_SETTINGS,
            payload: {
              title,
              Component,
              additionalProps,
            },
          })
        }
        popSettings={() =>
          dispatch({
            type: CustomizerActionType.POP_BLOCK_SETTINGS,
          })
        }
      />
    </div>
  )
}
